import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const Logo = () => (
  <svg viewBox="0 0 100.33 89.98" fill="currentColor" width="80" height="80">
    <path d="M27.53,89.98c-3.58,0-7.03-0.54-10.34-1.61c-3.32-1.07-6.25-2.68-8.79-4.83c-2.54-2.15-4.58-4.83-6.1-8.05C0.76,72.26,0,68.5,0,64.21c0-7.35,2.67-12.96,8.03-16.84c5.35-3.88,13.72-6.48,25.09-7.8c3.28-0.45,6.32-0.85,9.13-1.19c2.81-0.34,5.25-0.8,7.32-1.38c2.07-0.58,3.68-1.37,4.83-2.35c1.15-0.98,1.71-2.32,1.67-4.01v-3.62c0-3.01-0.49-5.78-1.47-8.31c-0.98-2.52-2.41-4.71-4.3-6.56c-1.88-1.85-4.23-3.28-7.04-4.3c-2.81-1.02-6.04-1.53-9.69-1.53c-3.24,0-6.19,0.38-8.85,1.13c-2.66,0.75-5.02,1.79-7.09,3.11c-2.07,1.32-3.82,2.87-5.26,4.66c-1.43,1.79-2.56,3.7-3.39,5.74l-6.5-2.43C4.97,12.28,9.06,7.63,14.75,4.58C20.44,1.53,26.66,0,33.4,0c4.86,0,9.55,0.94,14.07,2.83c4.56,1.88,8.33,4.9,11.31,9.04c2.79,4.11,4.18,9.31,4.18,15.6v60.65h-6.9V72.46h-0.51c-2.26,4.86-5.78,9.01-10.57,12.43C40.24,88.29,34.42,89.98,27.53,89.98z"/>
    <circle cx="93.99" cy="83.42" r="6.34"/>
  </svg>
);

export default function ScreenSaver({ onExit }) {
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [velocity, setVelocity] = useState({ x: 3, y: 2 });
  const [hue, setHue] = useState(0);
  const requestRef = useRef();

  useEffect(() => {
    const animate = () => {
      setPosition(prev => {
        let newX = prev.x + velocity.x;
        let newY = prev.y + velocity.y;
        let newVx = velocity.x;
        let newVy = velocity.y;

        if (newX <= 0 || newX >= window.innerWidth - 100) {
          newVx = -velocity.x;
          setHue(h => (h + 30) % 360);
        }
        if (newY <= 0 || newY >= window.innerHeight - 100) {
          newVy = -velocity.y;
          setHue(h => (h + 30) % 360);
        }

        setVelocity({ x: newVx, y: newVy });
        return { x: Math.max(0, Math.min(newX, window.innerWidth - 100)), y: Math.max(0, Math.min(newY, window.innerHeight - 100)) };
      });

      requestRef.current = requestAnimationFrame(animate);
    };

    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [velocity]);

  useEffect(() => {
    const handleInteraction = () => onExit?.();
    window.addEventListener('mousemove', handleInteraction);
    window.addEventListener('keydown', handleInteraction);
    window.addEventListener('click', handleInteraction);
    return () => {
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('click', handleInteraction);
    };
  }, [onExit]);

  return (
    <motion.div
      className="screen-saver"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div
        className="screen-saver-logo"
        style={{
          left: position.x,
          top: position.y,
          filter: `hue-rotate(${hue}deg)`,
        }}
      >
        <Logo />
        <span>Autonomous</span>
      </div>
    </motion.div>
  );
}
